import React from "react";
import KeywordsTag from './KeywordsTag';

const Japan = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="japanPublic"
        handwritingSrc="../../content/handwriting/japan.png"
        handwritingAlt="japan"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default Japan;